import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSession } from '@/store/useSession'

export function useLogout() {
  const navigate = useNavigate()
  const { userRole, clearSession } = useSession()

  return useCallback(() => {
    const destination = userRole === 'client' ? '/client-login' : '/login'
    clearSession()
    navigate(destination, { replace: true })
  }, [userRole, clearSession, navigate])
}
